import { ValueCount } from "@/rd/ResearchDataModel"
import { countBy } from "lodash"

export function getSortedValueCounts(values: string[]) {
    return Object.entries(countBy(values))
        .map(([value, count]) => ({ value, count } as ValueCount))
        .sort((a, b) => b.count - a.count || a.value.localeCompare(b.value)) // descending by count, then ascending lexical
}

export function getTopValues(values: string[], limit: number) {
    return getSortedValueCounts(values).slice(0, limit - 1)
}
